import {createStyles, makeStyles} from '@mui/styles';

const useStyles = ({
	enabled = false,
	cursor = 'grabbing',
}: UseDragGlobalStylesParams) =>
	makeStyles(() => {
		if (!enabled) return {};
		return createStyles({
			'@global': {
				html: {
					cursor: `${cursor} !important`,
				},
				body: {
					'& *': {
						userSelect: 'none !important',
						pointerEvents: 'none !important',
					},
				},
			},
		});
	});

export type UseDragGlobalStylesParams = {
	enabled?: boolean;
	cursor?: React.CSSProperties['cursor'];
};

export const useDragGlobalStyles = (params: UseDragGlobalStylesParams) => {
	// TODO: research the underworkings of makeStyles and see why a inline useMemo
	// does not work here
	useStyles(params)();
};

export default useDragGlobalStyles;
